import { render, staticRenderFns } from "./LiabilitiesModal.vue?vue&type=template&id=8dabbade&scoped=true"
import script from "./LiabilitiesModal.vue?vue&type=script&lang=js"
export * from "./LiabilitiesModal.vue?vue&type=script&lang=js"
import style0 from "./LiabilitiesModal.vue?vue&type=style&index=0&id=8dabbade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dabbade",
  null
  
)

export default component.exports